// Experience data lives in JSON (editable by humans, scripts, n8n).
// Validated against ExperienceSchema at module load.
import { ExperienceSchema, type Experience } from '@lib/schemas/experience';
import data from './data/experience.json';

export const experience: Experience = ExperienceSchema.parse(data);
